module.exports = __webpack_public_path__ + "img/servette-logo-icon.953f3668.png";